<div class="play-execution-nav-container">
  <nav #playExecutionTabNav mat-tab-nav-bar [tabPanel]="tabPanel">
    @for (playExecution of playExecutions; track playExecution) {
      <a mat-tab-link (click)="tabSelected(playExecution)" [active]="currentPlayExecution.id === playExecution.id"> {{ playExecution.startTime | date:'short' }} </a>
    }
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
